import { Button, Grid, withStyles } from '@material-ui/core';
import React from 'react';
import { useLang } from '../../../util/lang';

export const CustomConnectButton = withStyles({
    root: {
        backgroundColor: '#bfbfbf',
        color: '#ffff',
        '&:hover': {
            backgroundColor: '#a7a7a7',
        },
        width: 'auto',
    },
})(Button);

export const ConnectPlatformGrid = ({
    key,
    imgProps = { src: '', alt: '', height: 40 },
    scannerLabel = '',
    serverLabel = '',
    connected = false,
    openPlatformModal,
    disconnectPlatform,
}) => {
    const getPatientInfo = useLang('PatientInfo');
    return (
        <Grid item xs={3} key={key} style={{ padding: 18 }}>
            <Grid style={{ display: 'flex', alignItems: 'center', marginBottom: 8, gap: 20 }}>
                <img src={imgProps.src} alt={imgProps.alt} height={imgProps.height} />
                <Grid>
                    <p style={{ marginBottom: 8 }}>{serverLabel}</p>
                    {connected ? (
                        <Grid style={{ display: 'flex', gap: 6 }}>
                            <Button variant="contained" color="secondary" onClick={openPlatformModal}>
                                Select STL files
                            </Button>
                            <CustomConnectButton onClick={disconnectPlatform}>
                                <span>{getPatientInfo('OAuth.Disconnect')}</span>
                            </CustomConnectButton>
                        </Grid>
                    ) : (
                        <CustomConnectButton onClick={openPlatformModal}>
                            <span>Please connect</span>
                        </CustomConnectButton>
                    )}
                </Grid>
            </Grid>

            <Grid>
                <h3>
                    <strong style={{ fontWeight: 'bold', fontSize: 20 }}>{scannerLabel}</strong>
                </h3>
            </Grid>
        </Grid>
    );
};
